/*
 * Implementation of jQuery Toast Plugin by kamranahmedse
 *
 * See: https://github.com/kamranahmedse/jquery-toast-plugin/
 */

import { Injectable } from '@angular/core';
import * as jQuery from 'jquery';

// loading plugin (js and css)
import './baToastNotification.loader.ts';

// loading configuration class/interface
import { ToastConfig } from './models/ToastConfig';


@Injectable()
export class BaToastNotificationService{

    private _defaultConfig:ToastConfig;
    private _successConfig:ToastConfig;
    private _errorConfig:ToastConfig;
    private _infoConfig:ToastConfig;
    private _warningConfig:ToastConfig;

    // setting default configuration
    constructor(){
        this._defaultConfig = { text: '',position: "top-right" }

        this._successConfig = { text: '',position: "top-right", icon: 'success'}

        this._errorConfig = { text: '',position: "top-right", icon: 'error' }

        this._infoConfig = { text: '',position: "top-right", icon: 'info' }

        this._warningConfig = { text: '',position: "top-right", icon: 'warning' }
    }

    // method to set app-wide default toast configuration
    setToastDefaults(toastConfig:ToastConfig){
        this._defaultConfig = toastConfig;
    }

    // show toast
    showToast(toastConfig:ToastConfig){
        $['toast'](Object.assign(this._defaultConfig, toastConfig));
    }

    success(toastConfig:ToastConfig){
        $['toast'](Object.assign(this._successConfig, toastConfig));
    }

    error(toastConfig:ToastConfig){
        $['toast'](Object.assign(this._errorConfig, toastConfig));
    }

    info(toastConfig:ToastConfig){
        $['toast'](Object.assign(this._infoConfig, toastConfig));
    }

    warning(toastConfig:ToastConfig){
        $['toast'](Object.assign(this._warningConfig, toastConfig));
    }

    // hide all toasts
    clearAllToasts(){
        $['toast'].reset('all');
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/services/baToastNotification/baToastNotification.service.ts